export default "__VITE_ASSET__bzc_eQvM__"